import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _18UpRatingIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"18_up_rating"} ref={ref}/>
});

_18UpRatingIcon.displayName = "_18UpRatingIcon";
